module.exports = __webpack_public_path__ + "img/gris-5.aa4b9f71.png";